import React, { useContext } from 'react';
import classnames from 'classnames';
import UserMenuAvatar from './../../../_partials/UserMenu/UserMenuMobile/_partials/UserMenuAvatar';
import UserMenuMobile from '../../../_partials/UserMenu/UserMenuMobile';
import {
  UserMenuContext,
  UserMenuContextProvider,
} from '../../../_partials/UserMenu/UserMenuMobile/UserMenuContext';
import { useIosHeightHack } from './useIosHeightHack';

import s from './UserMenuButton.scss';

export interface Props {
  hideNotificationCount?: boolean;
  disableThemeSwitcher?: boolean;
  hasSubscriptions?: boolean;
  className?: string;
}

const UserMenuButton: React.FC<Props> = ({ className, ...props }) => {
  const {
    isSliding,
    isOpen: isUserMenuOpen,
    toggleUserMenu,
    setScrollableRef,
  } = useContext(UserMenuContext);
  const { isIosHeightHackNeeded, setRootRef } = useIosHeightHack();

  return (
    <div className={classnames(s['user-menu-wrapper'], isSliding && s['sliding'], className)}>
      {!isUserMenuOpen && (
        <span className={s['avatar-wrapper']}>
          <UserMenuAvatar />
        </span>
      )}
      <div
        className={classnames(s['user-menu-shade'], isUserMenuOpen && s['is-active'])}
        // Since react-onclickoutside wasn't really working for this component and my most
        // valiant efforts to make it do so were met with failure, just do it ourselves
        onTouchStart={toggleUserMenu}
        onClick={toggleUserMenu}
        aria-hidden={!isUserMenuOpen}
      />
      <div
        className={classnames(
          s['user-menu-list-wrapper'],
          isUserMenuOpen && s['is-opened'],
          isIosHeightHackNeeded && s['ios-sucks']
        )}
        ref={node => {
          setScrollableRef(node);
          setRootRef(node);
        }}
        aria-hidden={!isUserMenuOpen}
      >
        <UserMenuMobile {...props} />
      </div>
    </div>
  );
};
UserMenuButton.displayName = 'UserMenu';

const UserMenuButtonWithContextWrapper: React.FC<Props> = props => {
  return (
    <UserMenuContextProvider>
      <UserMenuButton {...props} />
    </UserMenuContextProvider>
  );
};
UserMenuButtonWithContextWrapper.displayName = 'UserMenuButtonWithContextWrapper';

export default UserMenuButtonWithContextWrapper;
